var minicart_v3 = {
  texts: general.decodeLocale(window.kef.minicart.texts),

  init: () => {
    if (window.kef.minicart.enable == false) return;

    const header_el = $('.shopify-section-header-v3');
    const minicart_el = $('.shopify-section-minicart-v3');
    const body = $('body');

    header_el
      .on('click', '.header-action-cart', function(e) {
        minicart_v3.open();
        e.preventDefault();
      })
  
    minicart_el
      .on('click', '.minicart-btn-close', function() {
        minicart_v3.close();
      })
  
    body
      .on('click', function(e) {
        if (e.target.nodeName == 'BODY' && $(e.target).hasClass('minicart-active')) {
          minicart_v3.close();
          e.preventDefault();
        }
      })
      .on('click', '.minicart-item-remove', function(e) {
        e.preventDefault();
    
        var item = $(this).parents('.minicart-item');
        var data = {};
        data['id'] = item.attr('data-id');
        data['quantity'] = 0;

        item.fadeOut('slow', function() {
          item.remove();
        });

        cart_fn.change(data).done(function(cart) {
          minicart_v3.updateTitle(cart, 'remove');

          $('.shopify-section-minicart-v3').trigger({
            type: 'remove_from_cart',
            datalayer: item.attr('data-datalayer'),
            cart: cart,
          });
        });
      });
  },
  open: () => {
    if (window.kef.minicart.enable == false) return;
    
    $('.minicart').addClass('active');
    global_fn.overlay.set('add', 'minicart-active');

    $(document).trigger({
      type: 'minicart_open',
    });
  },
  close: () => {
    if (window.kef.minicart.enable == false) return;
    
    $('.minicart').removeClass('active');
    global_fn.overlay.set('remove', 'minicart-active');

    $(document).trigger({
      type: 'minicart_close',
    });
  },
  update: (cart) => {
    var cart_item_count_total = cart.item_count
    $('.minicart-disclaimer-items .minicart-disclaimer-text').html('');

    $('.header-icon-cart-total-items').html(cart_item_count_total);

    if (cart_item_count_total > 0) {
      $('.minicart-container').addClass('has-items').scrollTop(0);

      var cart_item_txts = [];
      var cart_disclaimer_txts = [];

      var hb_tpl = $(`#minicart-item-hb`);
      for (var i = 0; i < cart.items.length; i++) {
        var cart_item = cart.items[i];
        cart_item.final_line_price_display = Shopify.formatMoney(cart_item.final_line_price, window.money_format);
        
        var tpl = Handlebars.compile(hb_tpl.html());
        cart_item_txts.push(tpl({
          item: cart_item,
          texts: minicart_v3.texts,
          close_button: window.kef.minicart.close_button
        }));

        if (cart_item.properties != null && cart_item.properties.hasOwnProperty('note') && cart_item.properties.note != '') {
          cart_disclaimer_txts.push(cart_item.properties.note.replace('This product', cart_item.product_title));
        }
      }

      if (cart_item_txts.length > 0) {
        $('.minicart-items').html(cart_item_txts.join(''));
      }

      if (cart_disclaimer_txts.length > 0) {
        $('.minicart-disclaimer-items .minicart-disclaimer-text').html(`
          ${window.kef.minicart.please_note_that}<br>
          ${cart_disclaimer_txts.join('<br>')}
        `);
        $('.minicart-disclaimer-items').removeClass('hide');
      }

      $('.minicart-disclaimer-default').removeClass('hide');

      $('.minicart-quicklinks').addClass('hide');
      $('.minicart-payment-gateway').removeClass('hide');
      $('.minicart-footer').removeClass('hide');
      $('.minicart-product-recommendation').removeClass('hide');
    } else {
      $('.minicart-container').removeClass('has-items');

      $('.minicart-items').html('').empty();

      $('.minicart-disclaimer-items').addClass('hide');
      $('.minicart-disclaimer-default').addClass('hide');

      $('.minicart-quicklinks').removeClass('hide');
      $('.minicart-payment-gateway').addClass('hide');
      $('.minicart-footer').addClass('hide');
      $('.minicart-product-recommendation').addClass('hide');
    }

    $(document).trigger({
      type: 'minicart_update',
    });
  },
  updateTitle: (cart, action = '') => {
    var cart_item_count_total = cart.item_count;
    var minicart_title_text = '';
    var minicart_title_count = '';

    if (action == 'add') {
      minicart_title_text = minicart_v3.texts.titles.add_to_cart_title
    } else if (cart_item_count_total == 0) {
      minicart_title_text = minicart_v3.texts.titles.empty_cart_title
    } else {
      minicart_title_text = minicart_v3.texts.titles.default_title;

      if (cart_item_count_total == 0) {
        minicart_title_count = `${cart_item_count_total} ${minicart_v3.texts.item_count.zero}`;
      } else if (cart_item_count_total == 1) {
        minicart_title_count = `${cart_item_count_total} ${minicart_v3.texts.item_count.one}`;
      } else {
        minicart_title_count = `${cart_item_count_total} ${minicart_v3.texts.item_count.other}`;
      }
    }

    $('.minicart-title-text').html(minicart_title_text);
    $('.minicart-count').html(minicart_title_count);
  },
  showError: (msg) => {
    $('.minicart-error-message').html(msg);
    setTimeout(minicart_v3.clearError, 8000);
  },
  clearError: () => {
    $('.minicart-error-message').html('');
  },
}
$(function() {
  minicart_v3.init();
});